//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import qs from 'qs'
import dateDiff from '../utils/dateDiff'

// 是否是H5渠道
let h5 = false

export default {
  name: 'm-message',
  mounted () {
    if (this.$route.query.utmSource && this.$route.query.utmSource === 'h5') {
      this.h5 = true
    }
    const data = {
      'productsCode': this.$route.params.productId,
      'page.currentPage': ++this.currentPage,
      'page.showCount': 10
    }
    let evaluationPageURL = '/api/baokuan/evaluationPage'
    if (this.h5) evaluationPageURL = '/api/baokuan/evaluationPage'
    this.$http.get(evaluationPageURL + '?' + qs.stringify(data)).then(response => {
      this.totalNumber = response.data.page.totalResult
      this.totalPage = Math.ceil(response.data.page.totalResult / 10)
      response.data.dataList.forEach((ele) => {
        if (/^1[34578]\d{9}$/.test(ele.utTdnick)) {
          const s1 = ele.utTdnick.substr(0, 3)
          const s2 = ele.utTdnick.substr(8, 4)
          ele.utTdnick = s1 + '****' + s2
        }
        this.allMessages.push({user: ele.utTdnick, message: ele.ptNotes, date: new Date(ele.createTime)})
      })
      setTimeout(() => {
        this.$emit('on-messageReady')
      }, 300)
    })
  },
  data () {
    return {
      showMoreState: true,
      currentPage: 0,
      totalPage: 0,
      totalNumber: 0,
      allMessages: [],
      h5: h5
    }
  },
  computed: {
    messages () {
      this.allMessages.forEach((ele) => {
        if (typeof ele.date !== 'string') {
          ele.date = dateDiff(ele.date)
        }
      })
      if (this.showMoreState) {
        return this.allMessages.slice(0, (this.currentPage - 1) * 10 + 4)
      } else {
        return this.allMessages
      }
    },
    moreTips () {
      if (this.showMoreState) {
        return '查看更多(' + (this.totalNumber - (this.currentPage - 1) * 10 - 4) + ')'
      } else {
        return '收起全部'
      }
    }
  },
  methods: {
    showMore () {
      if (this.currentPage >= this.totalPage && this.showMoreState === true) {
        this.showMoreState = false
        return
      }
      if (this.showMoreState === false) { // 收起
        this.currentPage = 1
        this.allMessages = this.allMessages.slice(0, 10)
        this.showMoreState = true
        return
      }
      const data = {
        'productsCode': this.$route.params.productId,
        'page.currentPage': ++this.currentPage,
        'page.showCount': 10
      }
      this.$http.get('/api/baokuan/evaluationPage?' + qs.stringify(data)).then(response => {
        response.data.dataList.forEach((ele) => {
          if (/^1[34578]\d{9}$/.test(ele.utTdnick)) {
            const s1 = ele.utTdnick.substr(0, 3)
            const s2 = ele.utTdnick.substr(8, 4)
            ele.utTdnick = s1 + '****' + s2
          }
          this.allMessages.push({user: ele.utTdnick, message: ele.ptNotes, date: new Date(ele.createTime)})
        })
        if (this.messages.length === this.totalNumber) {
          this.showMoreState = false
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Message.vue